import { Component, React, useEffect, useState } from 'react'
import './nftconfirmation.css'
import firebase from 'firebase/compat/app';
import { Link, BrowserRouter,Redirect  as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import Web3 from 'web3';
import '../Spbdrop/spb.css'
import { event } from 'react-ga';
require('dotenv').config()


function Nft_conformation () {
    
   

   /* detect if the page is refreshed and redirect to home */
   window.onbeforeunload = function(event) {
    if (event.clientX > document.body.clientWidth && event.clientY < 0 || event.altKey) {
        
        event.returnValue = 'Are you sure you want to leave?';
        window.location.replace("/");
    }
};

   /* detect if back button is pressed and redirect to home */
    window.onunload = function(event) {
    if (event.clientX > document.body.clientWidth && event.clientY < 0 || event.altKey) {

        event.returnValue = 'Are you sure you want to leave?';
        window.location.replace("/");
    }

    };

    /* detect if the user is using the browser back button and redirect to home */
    window.onpopstate = function(event) {
    if (event.clientX > document.body.clientWidth && event.clientY < 0 || event.altKey) {

        event.returnValue = 'Are you sure you want to leave?';
        window.location.replace("/");
    }

    };

    /* detect if the user is using the browser forward button and redirect to home */
    window.onpageshow = function(event) {
    if (event.clientX > document.body.clientWidth && event.clientY < 0 || event.altKey) {

        event.returnValue = 'Are you sure you want to leave?';
        window.location.replace("/");
    }

    };





    
    /* disable right click */
    document.oncontextmenu = function () {
        return false;
    }
    document.onselectstart = function () {
        return false;
    }
    document.onkeydown = function () {
        if (window.event && window.event.keyCode == 123) {
            return false;
        }
    }
    /* disable ctrl+R */
    document.onkeydown = function (e) {
        if (e.ctrlKey && e.keyCode == 82) {
            return false;
        }
    }
     /* disable ctrl+F5 */
    document.onkeydown = function (e) {
        if (e.ctrlKey && e.keyCode == 116) {
            return false;
        }
    }
    
    /* redirect to home page if user is not logged in */
    if(!firebase.auth().currentUser){
        window.location.href = '/';
    }
    
    const nftid = useRouteMatch().params.nftid;
    const encrypted_file_id = useRouteMatch().params.uuid;
    /* replace special characters */
    const new_file_id = encrypted_file_id.replace('xMl3Jk', '+' ).replace('Por21Ld', '/').replace('Ml32', '=');
    //alert(new_file_id);
    /* decrypt the file id */
    var cryptoJS = require("crypto-js");
    const decrypted_file_id = cryptoJS.AES.decrypt(new_file_id, ''+process.env.REACT_APP_SECRET_KEY).toString(cryptoJS.enc.Utf8);
    //alert(decrypted_file_id)
    if (decrypted_file_id !== nftid) {
        window.location.href = '/';
    }
    
    const [nftData, setNftData] = useState('');
    const [tokenId, setTokenId] = useState('');
    const [txdata, setTxdata] = useState('');
    
    useEffect(() => {
        
        const popupState = true;
        loadingPopup(popupState)
        /* get nft details from firebase */
        firebase.firestore().collection('NFTs').doc(nftid).get().then(doc => {
            if (!doc.exists) {
                //console.log('No such document!');
            } else {
                    setNftData(doc.data());
                    //console.log('Document data:', doc.data());
                    localStorage.setItem('nftData', JSON.stringify(doc.data()));
                    mintNFT(doc.data());
                }
            }).catch(err => {
                console.log('Error getting document', err);
            });

            /* get last token id from firebase */

        firebase.firestore().collection('nfttoken').doc('MDoA82I34EMQzAqksKLm').get().then(doc => {
            
            if (!doc.exists) {
                //console.log('No such document!');
            } else {
                    setTokenId(doc.data());
                    //console.log('Token Id:', doc.data());
                    tokenid(doc.data());
                }
            }).catch(err => {
                //console.log('Error getting document', err);
            });       
            
        function tokenid(token){
            //console.log(token)
            localStorage.setItem('tokenId', JSON.stringify(token.token));
        }

        /* calling mint function */
        const NFTData = JSON.parse(localStorage.getItem('nftData'));
        
        const mintNFT =  (data) => {    
            const walletaddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT');
            const TokenID = JSON.parse(localStorage.getItem('tokenId'))
            const mint_url = "https://api-us-west1.tatum.io/v3/nft/mint";
            const mint_body = {
                "chain" : "MATIC",
                "tokenId" : ""+TokenID,
                "to" : walletaddress,
                "contractAddress" : "0xa3aedcbc94534186480abd392977772eda16ffa4",
                "url" : data.nft_media_url,
                "authorAddresses" : [
                "0x9C26245C14276b6C83449517f95Ed939E24748AB"
            ],
            "provenance": true,
            "fromPrivateKey" : process.env.REACT_APP_PRIVATE_KEY,}
            
            const mint_options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key' : '510acc11-8d77-46c1-b871-9a46802e7c93',
                'x-testnet-type' : 'ethereum-ropsten'
            },
            body: JSON.stringify(mint_body)}
            
            fetch(mint_url, mint_options)
            .then(res => res.json())
            .then((result) => {
                //console.log(result);
                setTxdata(result);
                updateTokenId();
                const txhash = result.txId;
                confirmEtherTransaction(txhash);
            },
            (error) => {
                // console.log(error);
            }
        ) 
    }
    
    /* update tokenid in firebase */
    const updateTokenId = async () => {
    firebase.firestore().collection('nfttoken').doc('MDoA82I34EMQzAqksKLm').update({
        "token": firebase.firestore.FieldValue.increment(1)
    })
    .then(function() {
        // console.log("Document successfully written!");
    })
    .catch(function(error) {
        // console.error("Error writing document: ", error);
    });}
    
    /* transaction status */
    async function getConfirmations(txHash) {
        try {
            // Instantiate web3 with HttpProvider
            const web3 = new Web3('https://polygon-mumbai.infura.io/v3/5b9cdbc4c85947dd90e13c0bd2f0c5a6')
            // Get transaction details
            const trx = await web3.eth.getTransaction(txHash)
            // Get current block number
            const currentBlock = await web3.eth.getBlockNumber()
            // When transaction is unconfirmed, its block number is null.
            // In this case we return 0 as number of confirmations
            return trx.blockNumber === null ? 0 : currentBlock - trx.blockNumber
        }
        catch (error) {
            // console.log(error)
        }
    }
    
    function confirmEtherTransaction(txHash, confirmations = 1) {
        setTimeout(async () => {
            
            // Get current number of confirmations and compare it with sought-for value
            const trxConfirmations = await getConfirmations(txHash)
            // console.log('Transaction with hash ' + txHash + ' has ' + trxConfirmations + ' confirmation(s)')
            if (trxConfirmations >= confirmations) {
                // Handle confirmation event according to your business logic
                // console.log('Transaction with hash ' + txHash + ' has been successfully confirmed!')
                loadingPopup(false)
                storedata(txHash);
                // stop function
                return
            }
            else {
                // Recursive call
                return confirmEtherTransaction(txHash, confirmations)
            }
        }, 30 * 1000)
    }
        
    function loadingPopup(value){
        // console.log(value)
        if( value == true){
            document.querySelector('.spinner-over').classList.remove('completed')
            document.querySelector('.spinner-over').classList.add('half-spinner')
            document.querySelector('.spinner').classList.add('spinner-active')
        } else if( value == false){
            document.querySelector('.spinner-over').classList.remove('half-spinner')
            document.querySelector('.spinner-over').classList.add('completed')
            setTimeout(() => {
                document.querySelector('.spinner').classList.remove('spinner-active')
            }, 5000);
        } else if( value == null){         
            document.querySelector('.spinner-over').classList.remove('completed')
            document.querySelector('.spinner-over').classList.remove('half-spinner')
            setTimeout(() => {
                document.querySelector('.spinner').classList.remove('spinner-active')
            }, 5000);
        }
    }
    
    /* storing data in firebase */
    function storedata(txHash){
        firebase.firestore().collection('purchases').add({
        txnid: txHash,
        uid: firebase.auth().currentUser.uid,
        walletaddress: localStorage.getItem('LAST_ACTIVE_ACCOUNT'),
        email: firebase.auth().currentUser.email,
        tokenid: localStorage.getItem('tokenId'),
        timestamp: new Date(),
        nftid: NFTData.id,
        nft: NFTData
       })
       .then(function(docRef) {
           //console.log("Document written with ID:  ", docRef.id);
           sendEmail();
        })
        .catch(function(error) {
            //console.error("Error adding document: ", error);
        });
        function sendEmail(){
            fetch(`https://us-central1-diginoor-3755e.cloudfunctions.net/app/sendEmail?to_email=${firebase.auth().currentUser.email}&subject=Your NFT Purchase is Confirmed&message=You have successfully purchased ${NFTData.nft_title} NFT for ${NFTData.price}USD. You can view your purchase under showcase tab in profile page.`,
            {
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }
            })
            .then(res => res.json())
            .then(result => {
                //console.log(result);
            })
            .catch(error => {
                //console.log(error);
            })
        }
    }
}, []);

    return (
    <>
    <div className="spinner">
        <span>Confirming. Please don't refresh or close the tab</span>
        <div className="spinner-over half-spinner"></div>
    </div>
    <div className="nft-confirmation">
        <div className="confirmation-section">
            <div className="confirmation-section-col1">
                <div className="confirmation-card">
                    <div className="confirmation-cardim">
                        <img src={nftData.nft_thumb} className="confirmation-top-im"></img>
                    </div> 
                    <div className="about-top-details">
                        <p className="confirmation-card-title">{nftData.nft_title}</p>
                        <p className="confirmation-card-title1">{nftData.collection}</p>
                    </div>
                </div>
            </div>
            <div className="confirmation-section2-col2">
                <h2>Your NFT is<br/>on it's way!</h2>
                <p>Congratulations! You've claimed your NFT,
                    it's currently being transferred to your wallet. Please wait 20 - 30 minutes to complete.</p>
                <a 
                href ={` https://twitter.com/intent/tweet?text=Check out my latest NFT investment 📈 with @diginoor_NFT 💎https://diginoor.io/nftdetails/${nftData.id} `}
                 target="_blank"> <button className="tweet-button"><i className="fab fa-twitter"></i>Tweet it</button></a> 
                <Link to ="/profile"> <button className="continue-button">Continue</button></Link>
                <div className="proof-auth">
                    <a href={` https://polygonscan.com/tx/${txdata.txId}`} target="_blank">VIEW TRANSACTION <i className="fas fa-external-link-square-alt external"></i></a>
                </div>                                      
            </div>
        </div>
    </div>
    </>
    );
}
    
export default Nft_conformation;